<template>
    <div class="flat_flag_row">
        <div class="row align-items-center">
            <div class="col col-1 text-center">
                <RiskLevelDumpling :value="flag.risk" :level="versionRiskLevel(flag, version)" />
            </div>
            <div class="col col-3 group">
                {{ flag.flag_type_group_name }}&nbsp;
                <a :href="flagUrl(flag.flag_type_group_documentation_url)" target="_blank" v-if="flag.flag_type_group_documentation_url">
                    <b-icon icon="question-circle"
                        font-scale="0.95"
                        variant="dark"
                        class="ml-1"
                    />
                </a>
            </div>
            <div class="col">
                <h4 class="name">
                    {{ flag.flag_type_name }}&nbsp;
                    <a :href="flagUrl(flag.flag_type_documentation_url)" target="_blank" v-if="flag.flag_type_documentation_url">
                        <b-icon icon="question-circle"
                            font-scale="0.95"
                            variant="dark"
                            class="ml-1"
                        />
                    </a>
                </h4>
                <p v-if="flag.description" class="description" v-html="flag.description"/>
            </div>
        </div>
    </div>
</template>

<script>
import RiskLevelDumpling from "@/components/RiskLevelDumpling.vue";
import riskMixin from "@/plugins/riskMixin.js";

export default {
    props: {
        flag: {type: Object, required: true},
        version: {type: String, required: true}
    },
    components: { RiskLevelDumpling },
    mixins: [riskMixin],
    methods: {
        flagUrl(documentation_url){
            return "https://popisrizik.datlab.eu" + documentation_url
        }
    }
}
</script>

<style lang="scss">

@use '@/scss/custom';

.flat_flag_row {
    background-color: #f8f8f8;
    border-radius: 8px;
    padding: 20px 0;
    margin-bottom: 10px;

    .group {
        font-size: 16px;
        color: custom.$body-color;
        font-weight: 600;
    }

    .name {
        font-size: 16px;
        color: custom.$body-color;
        font-weight: 600;
    }

    .description {
        font-size: 14px;
        color: custom.$dark;
        margin: 0;
    }
}
</style>